export enum LifeCyclePhase{
    None = 0,
    Design = 1,
    Build = 2,
    Deploy = 3,
    Test = 4,
    Operate = 5,
    Retire = 6
}